<div *ngIf="entity" editorType="medium">
  <form *ngIf="form" [formGroup]="form">
    <div class="column">
      <dx-text-box formControlName="code" [label]="'common.code' | translate" formField></dx-text-box>
      <dx-text-box formControlName="name" [label]="'common.name' | translate" formField></dx-text-box>
    </div>
  </form>
  <div class="controls" *ngIf="steps">
    <dx-tab-panel>
      <dxi-item style="display: flex;" [title]="'common.steps' | translate | ucfirst">
        <dx-data-grid
          [createComponent]="stepsAddComponent"
          [customParams]="{ parentId: entity!.id }"
          [glamResource]="steps"
        >
          <dxi-column
            [link]="{ editComponent: stepsEditComponent }"
            [allowEditing]="false"
            dataField="instructions"
            dataType="string"
            [caption]="'entity.workProcedure.step.instructions' | translate | ucfirst"
          ></dxi-column>
          <dxi-column
            cellTemplate="checkpointCellTpl"
            [allowEditing]="false"
            dataField="checkpointId"
            [caption]="'common.checkpoint' | translate | ucfirst"
          >
            <div *dxTemplate="let cell of 'checkpointCellTpl'">
              {{ getCheckpointName(cell.data.checkpointId) }}
            </div>
          </dxi-column>
          <dxi-column
            cellTemplate="defaultValuesCellTpl"
            [allowEditing]="false"
            dataField="defaultValues"
            [caption]="'entity.workProcedure.step.defaultValues' | translate | ucfirst"
          >
            <div *dxTemplate="let cell of 'defaultValuesCellTpl'">
              {{ formatDefaultValues(cell.value) }}
            </div>
          </dxi-column>
          <dxi-column
            [allowEditing]="false"
            dataField="instructionsValue"
            dataType="number"
            [caption]="'entity.workProcedure.step.instructionsValue' | translate | ucfirst"
          ></dxi-column>
          <dxi-column
            [allowEditing]="false"
            dataField="required"
            dataType="boolean"
            [caption]="'entity.workProcedure.step.required' | translate | ucfirst"
          ></dxi-column>
        </dx-data-grid>
      </dxi-item>
    </dx-tab-panel>
  </div>
</div>
